export const phone = "+7 (961) 006-80-14";
export const phoneLink = "tel:+79610068014";
export const email = "info@mskhelp.ru";
export const telegram = "https://t.me/+79220198891";
export const whatsapp = "https://wa.me/79220198891";

export const services = [
  {
    title: "Выездной автосервис",
    price: "от 500 руб.",
    time: "30-180 мин",
    icon: "🔧",
  },
  {
    title: "Замена колеса на месте",
    price: "от 1 000 руб.",
    time: "30-180 мин",
    icon: "⚙️",
  },
  {
    title: "Ремонт проколов и порезов",
    price: "от 1 000 руб.",
    time: "40-180 мин",
    icon: "🛠️",
  },
  {
    title: "Помощь на дороге",
    price: "от 1 000 руб.",
    time: "10-280 мин",
    icon: "🚑",
  },
  {
    title: "Эвакуация авто",
    price: "от 12 000 руб.",
    time: "30-180 мин",
    icon: "🚛",
  },
  {
    title: "Прикуривание",
    price: "800 руб.",
    time: "10-60 мин",
    icon: "🔋",
  },
];

export const whyUs = [
  "Работаем 24/7, без выходных",
  "Приезжаем быстро — 20–40 мин",
  "Только профессиональное оборудование",
  "Фиксированные цены без скрытых платежей",
  "Опыт мастеров — от 5 лет",
  "Наличный и безналичный расчёт",
];

export const equipment = [
  "Мобильный компрессор 12–15 Bar",
  "Генератор 8.5 кВт",
  "Гидравлический домкрат 7 т",
  "Балансировочный станок",
  "Набор ударных головок",
  "Пневмогайковерт",
  "Набор для ремонта RunFlat",
];

export const howItWorks = [
  { step: 1, title: "Заявка", desc: "Позвоните или оставьте заявку на сайте." },
  { step: 2, title: "Диагностика", desc: "Мастер приедет и определит неисправность." },
  { step: 3, title: "Ремонт", desc: "Выполним работы на месте." },
  { step: 4, title: "Вы довольны", desc: "Оплата после выполнения." },
];

export const prices = [
  { name: "Выезд в пределах МКАД", price: "1 500 ₽" },
  { name: "Выезд в пределах МКАД (22:00-07:00)", price: "2 000 ₽" },
  { name: "Выезд за МКАД", price: "2 000 ₽ + 40 ₽/км" },
  { name: "Выезд за МКАД (22:00-07:00)", price: "2 500 ₽ + 40 ₽/км" },
  { name: "Минимальный заказ в МКАД", price: "2 500 ₽" },
  { name: "Минимальный заказ за МКАД", price: "3 500 ₽" },
];

export const faq = [
  {
    q: "Сколько времени занимает приезд мастера?",
    a: "В среднем мастер приезжает за 20–40 минут после подтверждения заявки. Точное время зависит от вашего местоположения и загруженности дорог.",
  },
  {
    q: "Вы работаете круглосуточно и в выходные?",
    a: "Да, мы работаем 24/7, без выходных и праздников.",
  },
  {
    q: "Какие автомобили вы обслуживаете?",
    a: "Легковые автомобили, кроссоверы, внедорожники, коммерческий транспорт. Работаем с колёсами R13–R22.",
  },
  {
    q: "Что делать, если колесо не подлежит ремонту?",
    a: "Установим запасное колесо или поможем подобрать оптимальное решение (временный вариант или эвакуация).",
  },
  {
    q: "Есть ли гарантия на выполненные работы?",
    a: "Да, мы даём гарантию на все виды ремонта. Используем профессиональные материалы и оборудование.",
  },
  {
    q: "Какие способы оплаты вы принимаете?",
    a: "Наличные, банковская карта, перевод. Оплата после выполнения работ.",
  },
  {
    q: "Нужно ли заранее готовить автомобиль или инструменты?",
    a: "Нет, мастер приезжает со всем необходимым оборудованием.",
  },
];

export const testimonials = [
  {
    name: "Алексей",
    car: "BMW X5",
    text: "Пробил колесо по дороге на работу, позвонил — мастер приехал примерно за полчаса. Всё сделал быстро и аккуратно, видно, что оборудование профессиональное. Цена как озвучили по телефону, без сюрпризов. Очень выручили.",
    avatar: "https://i.pravatar.cc/100?u=1",
  },
  {
    name: "Марина",
    car: "Mercedes-Benz GLC",
    text: "Колесо спустило вечером во дворе, ехать было страшно. Приехали ночью, всё спокойно заменили и проверили давление. Очень вежливый мастер, всё объяснил. Спасибо за оперативность и человеческое отношение.",
    avatar: "https://i.pravatar.cc/100?u=2",
  },
  {
    name: "Игорь",
    car: "Volkswagen Multivan",
    text: "Нужно было срочно заменить колесо на трассе. Приехали быстро, сразу видно — не «гаражный» сервис. Всё оборудование с собой, работа чёткая и без суеты. Буду рекомендовать.",
    avatar: "https://i.pravatar.cc/100?u=3",
  },
  {
    name: "Дмитрий",
    car: "Audi A6",
    text: "Поймал саморез, думал, что придётся эвакуатор вызывать. В итоге всё отремонтировали на месте за 20 минут. Очень удобно, что никуда ехать не нужно. Отличный сервис.",
    avatar: "https://i.pravatar.cc/100?u=4",
  },
];